import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react"
import EvaluationForm from './EvaluationForm';
import References from './References';
import './App.css';

function App() {
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const toggleTheme = () => {
    setIsDarkTheme(!isDarkTheme);
    document.body.classList.toggle('dark-theme');
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [showForm]);

  return (
    <Router>
      <Analytics />
      <div className={`App ${isDarkTheme ? 'dark-theme' : ''}`}>
        {/* Navbar */}
        <nav className="navbar">
          <div className="nav-logo">
            <Link to="/">教师职业紧张评估系统</Link>
          </div>
          <div className="nav-links">
            <button onClick={toggleTheme} className="theme-toggle">
              {isDarkTheme ? '☀️' : '🌙'}
            </button>
            <Link to="/references">相关文献</Link>
            <a href="#contact">联系我们</a>
          </div>
        </nav>

        <Routes>
          <Route path="/references" element={<References />} />
          <Route path="/" element={
            !showForm ? (
              <>
                {/* Hero Section */}
                <section className="hero">
                  <div className="hero-image">
                    <img src="/hero.jpg" alt="Stressed Teacher" />
                  </div>
                  <div className="hero-content">
                    <h1>教师职业紧张评估系统</h1>
                    <p>通过科学的评估方法，帮助教师了解自己的工作生活状态，提供个性化的建议。</p>
                  </div>
                </section>

                {/* Introduction Blocks */}
                <section className="intro-blocks">
                  <h2>关于评估</h2>
                  <div className="blocks-container">
                    <div className="intro-block">
                      <h3>评估目的</h3>
                      <div className="block-content">
                        <p>帮助教师了解自己的工作生活平衡状况，发现潜在问题，提供改善建议。</p>
                      </div>
                    </div>
                    <div className="intro-block">
                      <h3>评估方法</h3>
                      <div className="block-content">
                        <p>采用科学的评估指标，从多个维度进行分析，确保评估结果的准确性和可靠性。</p>
                      </div>
                    </div>
                    <div className="intro-block">
                      <h3>评估价值</h3>
                      <div className="block-content">
                        <p>为教师个人发展提供参考，助力教育工作者实现更好的工作生活平衡。</p>
                      </div>
                    </div>
                  </div>
                  <button className="start-button" onClick={() => setShowForm(true)}>
                    开始评估
                  </button>
                </section>
              </>
            ) : (
              <EvaluationForm />
            )
          } />
        </Routes>

        {/* Contact Section */}
        <section id="contact" className="contact">
          <h2>联系我们</h2>
          <div className="contact-content">
            <div className="contact-info">
              <p>📧 Email: <a href='mailto:575752799@qq.com'>575752799@qq.com</a><br></br>
                &emsp;&emsp;&emsp;&emsp;&nbsp; <a href='mailto:2421548656@qq.com'>2421548656@qq.com</a>
              </p>
            </div>
            <div className="contact-description">
              <p>如果您有任何问题或建议，欢迎随时与我们联系。</p>
              <p>我们的工作时间：周一至周五 9:00-17:00</p>
            </div>
          </div>
        </section>
      </div>
    </Router>
  );
}

export default App;
